<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        Cantidad Riego
      </v-toolbar-title>
      <v-layout>
        <v-flex> </v-flex>
        <v-flex> </v-flex>
        <v-flex> </v-flex>
        <v-flex> </v-flex>
        <v-flex>
          <v-select
            :items="subprojects"
            name="name"
            item-text="name"
            label="Selecciona Rancho"
            @change="selectSubproject($event)"
          />
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" max-width="1400px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <template>
                <div>
                  <v-form>
                    <v-data-table
                      disable-initial-sort
                      :headers="headers2"
                      :items="items"
                      :pagination.sync="pagination"
                      class="elevation-2"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.nave }}</td>
                        <!-- <td>{{ props.item.sector }}</td> -->
                        <td>
                          <v-text-field
                            :rules="rules"
                            v-model="props.item.netajet"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            :rules="rules"
                            v-model="props.item.total"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            :rules="rules"
                            v-model="props.item.mlDrenaje"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            :rules="rules"
                            v-model="props.item['Na drenaje']"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td class="justify-center">
                          <!-- <v-btn small color="green" @click="submitItem(props)">
                            <v-icon color="white">check</v-icon>
                          </v-btn> -->
                          <v-btn small color="green" @click="submitItem(props)"
                            >Aceptar
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-form>
                </div>
              </template>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <!-- <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      disable-initial-sort
      :headers="headers"
      :items="entry"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.nave }}</td>
        <td class="text-xs-right">{{ props.item.sector }}</td>
        <td class="text-xs-right">{{ props.item.netajet }}</td>
        <td class="text-xs-right">{{ props.item.total }}</td>

        <td class="text-xs-right">{{ props.item.drenaje }}</td>
        <td class="text-xs-right">{{ props.item["mg Na riego"] }}</td>
        <td class="text-xs-right">{{ props.item["mg Na drenaje"] }}</td>
        <td class="text-xs-right">{{ props.item["Na drenaje"] }}</td>
        <td class="text-xs-right">{{ props.item.balance }}</td>
        <td class="text-xs-right">
          {{ new Date(props.item.createdAt).toLocaleString() }}
        </td>
        <td class="justify-center layout px-0">
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    subprojects: [
      "Andromeda",
      "Aquila",
      "Argus",
      "Aries",
      "Perseo",
      "Aurora",
      "ID",
      "Banco Madre",
    ],
    Andromeda: [
      {
        nave: "Andromeda 1 V.1",
        sector: 1,
      },
      {
        nave: "Andromeda 1 V.2",
        sector: 2,
      },
      {
        nave: "Andromeda 1 V.3",
        sector: 3,
      },
      {
        nave: "Andromeda 1 V.4",
        sector: 4,
      },
      // {
      //   nave: "Andromeda 2 V.1",
      //   sector: 5,
      // },
      // {
      //   nave: "Andromeda 3 V.2",
      //   sector: 6,
      // },
      {
        nave: "Andromeda 4 V.1",
        sector: 7,
      },
      {
        nave: "Andromeda 4 V.2",
        sector: 7,
      },

      {
        nave: "Andromeda 6 V.1",
        sector: 9,
      },
      {
        nave: "Andromeda 6 V.2",
        sector: 9,
      },
      {
        nave: "Andromeda 6 V.3",
        sector: 9,
      },
      {
        nave: "Andromeda 7 V.1",
        sector: 10,
      },
      {
        nave: "Andromeda 7 V.2",
        sector: 10,
      },
      {
        nave: "Andromeda 7 V.3",
        sector: 10,
      },
      {
        nave: "Andromeda 8 V.1",
        sector: 11,
      },
      {
        nave: "Andromeda 8 V.2",
        sector: 11,
      },
      {
        nave: "Andromeda 8 V.3",
        sector: 11,
      },
      
    ],
    Aquila: [
      {
        nave: "Aquila 1 V.1 LADO SUR",
        sector: 1,
      },
      {
        nave: "Aquila 1 V.2 LADO SUR",
        sector: 2,
      },
      {
        nave: "Aquila 1 V.3 LADO NORTE",
        sector: 3,
      },
      {
        nave: "Aquila 1 V.4 LADO NORTE",
        sector: 4,
      },
      {
        nave: "Aquila 2 V.1 LADO SUR",
        sector: 5,
      },
      {
        nave: "Aquila 2 V.2 LADO SUR",
        sector: 6,
      },
      {
        nave: "Aquila 2 V.3 LADO NORTE",
        sector: 7,
      },
      {
        nave: "Aquila 2 V.4 LADO NORTE",
        sector: 8,
      },
      {
        nave: "Aquila 3 V.1",
        sector: 9,
      },
      {
        nave: "Aquila 3 V.2",
        sector: 10,
      },
      {
        nave: "Aquila 4 V.1",
        sector: 11,
      },
      {
        nave: "Aquila 4 V.2",
        sector: 12,
      },
      {
        nave: "Aquila 4 V.3",
        sector: 13,
      },
      {
        nave: "Aquila 5 V.1",
        sector: 14,
      },
      {
        nave: "Aquila 5 V.2",
        sector: 14,
      },
      {
        nave: "Aquila 5 V.3",
        sector: 15,
      },
      {
        nave: "Aquila 6 V.1",
        sector: 14,
      },
      {
        nave: "Aquila 7 V.3",
        sector: 15,
      },
      {
        nave: "Aquila 8 V.1",
        sector: 15,
      },
      {
        nave: "Aquila 8 V.2",
        sector: 16,
      },
      {
        nave: "Aquila 8 V.3",
        sector: 17,
      },
      {
        nave: "Aquila 9 V.1",
        sector: 18,
      },
      {
        nave: "Aquila 9 V.2",
        sector: 19,
      },
      {
        nave: "Aquila 9 V.3",
        sector: 20,
      },
      {
        nave: "Aquila 10 V.1",
        sector: 21,
      },
      {
        nave: "Aquila 10 V.2",
        sector: 22,
      },
      {
        nave: "Aquila 10 V.3",
        sector: 23,
      },
      {
        nave: "Aquila 11 V.1",
        sector: 24,
      },
      {
        nave: "Aquila 11 V.2",
        sector: 25,
      },
      {
        nave: "Aquila 11 V.3",
        sector: 26,
      },
      {
        nave: "Aquila 12 V.1",
        sector: 27,
      },
      {
        nave: "Aquila 12 V.2",
        sector: 28,
      },
      {
        nave: "Aquila 12 V.3",
        sector: 29,
      },
    ],
    Argus: [
      {
        nave: "Argus 4",
        sector: 1,
      },
      {
        nave: "Argus 12",
        sector: 2,
      },
      {
        nave: "Argus 3",
        sector: 3,
      },
      {
        nave: "Argus 10",
        sector: 4,
      },
      {
        nave: "Argus 2",
        sector: 5,
      },
      {
        nave: "Argus 6",
        sector: 6,
      },
      {
        nave: "Argus 6.1",
        sector: 6,
      },
      {
        nave: "Argus 1",
        sector: 7,
      },
      {
        nave: "Per 1 (Argus)",
        sector: 8,
      },
    ],
    Aries: [
      {
        nave: "Aries 1",
        sector: 1,
      },
      {
        nave: "Aries 2",
        sector: 2,
      },
      {
        nave: "Aries 3",
        sector: 3,
      },
      {
        nave: "Aries 4",
        sector: 4,
      },
      {
        nave: "Aries 5",
        sector: 5,
      },
      {
        nave: "Aries 6",
        sector: 6,
      },
      {
        nave: "Aries 7",
        sector: 7,
      },
    ],
    Perseo: [
      {
        nave: "Perseo Acodos",
        sector: "VV02",
      },
      {
        nave: "Perseo Nodriza",
        sector: "VV01",
      },
      {
        nave: "Perseo Semillero",
        sector: "VV03",
      },
      {
        nave: "Perseo SemilleroA",
        sector: "VV03",
      },
      {
        nave: "Perseo SemilleroB",
        sector: "VV05",
      },
      {
        nave: "Perseo EngordaA",
        sector: "EN01",
      },
      {
        nave: "Perseo EngordaB",
        sector: "EN02",
      },

      {
        nave: "Perseo Engorda21A",
        sector: "EN03",
      },
      {
        nave: "Perseo Engorda21B",
        sector: "EN04",
      },
      {
        nave: "Perseo Banco 28lts",
        sector: "BN01",
      },
      {
        nave: "Perseo Banco 165lts",
        sector: "BN02",
      },
    ],
    Aurora: [
      {
        nave: "Aurora 1",
        sector: 1,
      },
      {
        nave: "Aurora 2",
        sector: 2,
      },
      {
        nave: "Aurora 3",
        sector: 3,
      },
      {
        nave: "Aurora 4",
        sector: 4,
      },
      {
        nave: "Aurora 5",
        sector: 5,
      },
      {
        nave: "Aurora 6",
        sector: 6,
      },
      {
        nave: "Aurora 7",
        sector: 7,
      },
      {
        nave: "Aurora 8",
        sector: 8,
      },
      {
        nave: "Aurora 8.1",
        sector: 8,
      },
      {
        nave: "Aurora 9",
        sector: 9,
      },
      {
        nave: "Aurora 10",
        sector: 10,
      },
      {
        nave: "Aurora 11",
        sector: 11,
      },
      {
        nave: "Aurora 12",
        sector: 12,
      },
    ],
    ID: [
      {
        nave: "ID 1",
        sector: 1,
      },
      {
        nave: "ID 2",
        sector: 2,
      },
      {
        nave: "ID 3",
        sector: 3,
      },
      {
        nave: "ID 4",
        sector: 4,
      },
      {
        nave: "ID 5",
        sector: 5,
      },
    ],
    "Banco Madre": [
      {
        nave: "Banco AND1 LADO NORTE V1",
        sector: 1,
      },
      {
        nave: "Banco AND1 LADO SUR V4",
        sector: 2,
      },
      {
        nave: "BANCO AQ2 LADO NORTE V3",
        sector: 3,
      },
      {
        nave: "BANCO AQ2 LADO SUR V1",
        sector: 4,
      },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 60,
      totalItems: 0,
    },
    dialog: false,
    headers: [
      {
        text: "Nave",
        align: "left",
        sortable: false,
        value: "nave",
      },
      { text: "Sector Riego Q", value: "sector", align: "right" },
      { text: "Riego Total Netajet", value: "netajet", align: "right" },
      { text: "Riego Total", value: "total", align: "right" },
      { text: "% Drenaje", value: "drenaje", align: "right" },
      { text: "mg Na Riego", value: "mg Na riego", align: "right" },
      { text: "mg Na Drenaje", value: "mg Na drenaje", align: "right" },
      { text: "Na drenaje ", value: "Na drenaje mg", align: "right" },
      { text: "Balance", value: "balance", align: "right" },
      { text: "Fecha", value: "createdAt", align: "right" },
      { text: "Eliminar", value: "name", sortable: false },
    ],
    headers2: [
      {
        text: "Nave",
        align: "left",
        sortable: false,
        value: "nave",
      },
      // { text: "Sector Riego Q", value: "sector" },
      { text: "Riego Total Netajet", value: "netajet" },
      { text: "Riego Total", value: "total" },
      { text: "mL Drenaje", value: "mLDrenaje" },
      { text: "Na Drenaje", value: "Na drenaje" },
      { text: "Aceptar", value: "name", sortable: false },
    ],
    entry: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    rules: [
      (v) => !!v || "Este campo es necesario",
      (v) => /^\d+.+$/.test(v) || "Solo numeros son aceptados",
    ],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Ingreso" : "Edit Item";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.new();
  },
  methods: {
    selectSubproject: async function(event) {
      console.log("event", event);
      this.rancho = event;
      this.dialog = true;
      this.btnClicked(event);
    },
    new() {
      this.editedItem.date = `${new Date().getDate()}/${new Date().getMonth()}/${new Date().getFullYear()}`;

      this.$axios
        .get("/api/IrrigationReports/", this.editedItem)
        .then((response) => {
          console.log("resp", response);
          this.entry = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    btnClicked(e) {
      console.log(e);
      this.items = this[`${e}`];
    },
    deleteItem(item) {
      const index = this.entry.indexOf(item);
      const _id = {
        _id: this.entry[this.entry.indexOf(item)]._id,
      };
      confirm("¿Estas seguro que quieres eliminar este registro?");
      let r = confirm("¿Estas seguro que quieres eliminar este registro?");
      if (r == true) {
        this.entry.splice(index, 1);
        this.$axios.post("/api/DeleteIrrigationReports/", _id);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    submitItem(props) {
      console.log(props.item);
      console.log(props.index);

      let numPlant = 4;

      // if (props.item.nave.includes("Aries")) {
      //   numPlant = 3;
      // }
      // // AJUSTE CHRIS
      // if (props.item.nave.includes("Andromeda 1 Q1")) {
      //   console.log("Test 1.1")
      //   numPlant = 4;
      // }
      // if (props.item.nave.includes("Andromeda 1 Q2")) {
      //   console.log("Test 1.1")
      //   numPlant = 4;
      // }
      // if (props.item.nave.includes("Andromeda 1 Q3")) {
      //   console.log("Test 1.1")
      //   numPlant = 4;
      // }
      // if (props.item.nave.includes("Andromeda 1 Q4")) {
      //     console.log("Test 1.1")
      //     numPlant = 4;
      //   }
      // else if (props.item.nave.includes("Aurora")) {
      //   numPlant = 1;
      // }

      console.log("numPlant", numPlant, props.item.nave);

      // // FORMULAS DE CONVERSION
      let payload = props.item;
      // payload.netajet = payload.netajet * 1.024
      payload.total = payload.total * 1.024;
      payload.mlDrenaje = (payload.mlDrenaje * 1.024) / numPlant;
      payload.drenaje = payload.mlDrenaje / payload.total;
      payload["mg Na riego"] = payload.total * 0.023;
      payload["mg Na drenaje"] =
        ((payload.total * (payload.drenaje / 100)) / 1000) *
        payload["Na drenaje"] *
        100;
      payload.balance = payload["mg Na riego"] - payload["mg Na drenaje"];

      console.log(payload);

      this.$axios
        .post("/api/IrrigationReports/", props.item)
        .then((response) => {
          if (response.status === 200) {
            this.items = this.items.filter(function(obj) {
              return obj.nave !== props.item.nave;
              // console.log(this.items)
            });
            alert("Registro enviado!!!");
            this.new();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>
.v-card {
  padding: 30px !important;
}
</style>
